<template>
  <div v-if="!isCanUseTelegramBackButton" class="container py-4">
    <div class="row">
      <div class="col-12">
        <app-btn
          class="btn btn-primary btn-sm"
          :disabled="!isCanGoBack"
          @click="onBack"
        >
          Назад
        </app-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";

export default {
  name: "AppBackButton",
  components: {
    AppBtn,
  },
  props: {
    isCanUseTelegramBackButton: {
      type: Boolean,
      required: true,
    },
    isCanGoBack: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["goBack"],
  setup(props, { emit }) {
    const onBack = () => {
      emit("goBack");
    };

    return {
      onBack,
    };
  },
};
</script>
